import AppError from 'util/AppError';


class ErrorSystem {
  framework;

  constructor(_framework) {
    this.framework = _framework;
  }

  getAppError(error,userMessage,errorCode,exceptionType) {
    if(error !== null && error !== undefined) {
      if(error instanceof AppError) {
        let modifiedUserMessage = (userMessage !== null && userMessage !== undefined)?userMessage:error.userMessage;
        let modifiedErrorCode = (errorCode !== null && errorCode !== undefined)?errorCode:error.errorCode;
        let modifiedExceptionType = (exceptionType !== null && exceptionType !== undefined)?exceptionType:error.exceptionType;
        error.userMessage = modifiedUserMessage;
        error.errorCode = modifiedErrorCode;
        error.exceptionType = modifiedExceptionType;
        return error;
      }    
      else {
        let modifiedUserMessage = (userMessage !== null & userMessage !== undefined)?userMessage:error.message;
        let modifiedErrorCode = (errorCode !== null & errorCode !== undefined)?errorCode:"code-9999";
        let modifiedExceptionType = (exceptionType !== null & exceptionType !== undefined)?exceptionType:"UnknownException";      
        return new AppError(error.message,modifiedUserMessage,modifiedErrorCode,modifiedExceptionType);
      }
    }
    else {
      let modifiedUserMessage = (userMessage !== null && userMessage !== undefined)?userMessage:error.message;
      let modifiedErrorCode = (errorCode !== null && errorCode !== undefined)?errorCode:"code-9999";
      let modifiedExceptionType = (exceptionType !== null && exceptionType !== undefined)?exceptionType:"UnknownException";            
      return new AppError(error.message,modifiedUserMessage,modifiedErrorCode,modifiedExceptionType);
    }
  } 

  getUserMessage(errorCode,exceptionType,message) {
    return "["+errorCode+"]["+exceptionType+"] " + message; 
  }  

}


export default ErrorSystem;